let msalInstance = null;
let msalProgress = null;

export const setMsalValues = (instance,inProgress)=>{
    msalInstance = instance;
    msalProgress  = inProgress;
};

export const getMsalInstance =()=>msalInstance;
export const getMsalInProgress=()=>msalProgress;